import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useBodyScrollLock from 'hooks/useBodyScrollLock';
import poster from 'assets/products/images/ss26_poster.webp';
import posterImage from 'assets/products/images/ss26_poster.jpg';

const LoginPage = ({ handleShowLoading }) => {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const scrollableElRef = useRef(null);
  useBodyScrollLock(scrollableElRef);
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = event => {
    event.preventDefault();

    fetch(`https://ss26.thisisneverthat.com/products.json?auth=${password}`)
      .then(response => response.json())
      .then(data => {
        localStorage.setItem('auth', password);
        handleShowLoading();
        navigate('/');
      })
      .catch(error => {
        setErrorMessage('Problem with password.');
        setPassword('');
        inputRef.current.focus();
      });
  };

  const handlePasswordChange = event => {
    setPassword(event.target.value);
    setErrorMessage('');
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef.current]);

  return (
    <div ref={scrollableElRef} className={'login'}>
      <div className='login_container'>
        <picture>
          <source srcSet={poster} type='image/webp' />
          <img src={posterImage} alt={'poster_image'} />
        </picture>
        <div className={'login_text'}>
          <div className={'login_input'}>
            <p>Enter the site password and click submit.</p>
            <form onSubmit={handleSubmit}>
              <div className={'input_wrapper'}>
                <input
                  ref={inputRef}
                  name={'password'}
                  autoFocus
                  type={'password'}
                  maxLength='35'
                  required
                  onChange={handlePasswordChange}
                  autocomplete={'off'}
                  value={password}
                />
                {!password && <span className={'caret'}></span>}
              </div>
              {errorMessage && <span className={'error_message'}>{errorMessage}</span>}
              <input className='submit-btn' type='submit' value='SUBMIT' />
            </form>
          </div>
          <a href='mailto:info@thisisneverthat.com'>
            <span>info@thisisneverthat.com</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
